 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.core-js","19":"npm.create-react-class","20":"npm.d3-scale","21":"npm.dompurify","22":"npm.react-querybuilder","23":"npm.react-smooth","24":"npm.react-sortable-hoc","25":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"a2aa61b09e52766619ba","5":"4b507769becc8b313c55","6":"b60353fe52070d422928","7":"6d3ad3a1eaa54d06bf6c","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"ee66f2baeb6ce3af535b","14":"1b625f3378a9db60bbef","17":"d2a7ae28e5ef57d500ca","18":"aeda64833536ef365e2a","19":"df2336024ddc5dc39567","20":"53276394962f6600858a","21":"4753773ccd4f3f64929c","22":"aea9a033bfa0e2e2ff81","23":"60be86c4cd67c3937270","24":"754bb30c4f2a452a4882","25":"9df6564a3d733b74319f","27":"a6cee62f278992bed30c","28":"17e219b0cc1f8334b4e4","29":"6f283d5858dfd4857265","30":"33b74d0aa02d0b07d717","31":"98d54b4c612747f903c0","32":"c9799139be3da91b49e4","33":"f53236dca2a95b340327","34":"ca8e0991d42edb625335","35":"442e4a8a43924d3e0564","36":"0895a6e622fa4176bdc7","37":"572548174bda1a82bbe3","38":"3fd8daa992fad78382e3","39":"6a16b3e478a830210b4b","40":"2d3bdd33646f527c1c12","41":"ba85becf63823230853c","42":"9292aa8c695f3b697d08","43":"713334a89f9bc7efc2a0","44":"33d509b85caf2937f428","45":"2bb7e3217f3a4d7a62ce","46":"772ba9b5c9d50df3ace2","47":"555332e69fd4b2855872","48":"7d4cd1a13491bb04b858","49":"d164ce39e925f366594f","50":"8025c9352d65a88a38c3","51":"e10ddfb4172c53c78417","52":"ce83d755a06aceaf621f","53":"1ebfeff78b7ef7fa1801","54":"a8dd0c879c7b8d32aa9d","55":"d69da9d6ad4b9d1e627a","56":"ab2a484822858db98e57","57":"f723ba46fb640282138e","58":"213018aceeb0b91d22de","59":"e441858407f65ff8e981","60":"4d021e9fb1d7e91cd9f1","61":"0b163addb139d6a318a2","62":"993f4699de2f899e9fd9","63":"6ab5b8215e8478f11279","64":"eef2a08b1399706a49fb","65":"bc37186a6da401e586d7","66":"addc6a9ea93d76922872","67":"7c3dc52e3654b7a72851","68":"213397164100efb71788","69":"4a7fd906783c996c6a8f","70":"f7570b2e93261d44f226","71":"4c1587bca142c3a3f5c9","72":"d85178319992edd9d10c","73":"6dc3678a6249f332d782","74":"a76d647630aba74e7d74","75":"ee62a790572ad46a82c6","76":"a7002ce5dcd0432e0df9","77":"60e00563461ef9f3e56f","78":"8d8b4861f1d61e4a4d54","79":"968d077f592d39999e05","80":"61b8d9c3922b60c94635","81":"bb713c61f7fd0890815e","82":"8a2a4d3465f7fb0411ba","83":"9bf561c9df4b6d245200","84":"b7a53cda5164e02bfda8","85":"d277e5e9644d670830c1","86":"d0214f6409d111cd7dc8","87":"e81996a1c25e25b9b4bd","88":"bd25f6c749d704e2fa38","89":"d6317404ec126a3131ab","90":"a32dc0269ee95bab99c2","91":"f82e8e7bb72ce0bb36bb"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/95af017/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
